import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Button, Alert } from "@mui/material";
import { motion } from "framer-motion";
import AuthContext from "../../../contexts/auth-context";
import useAxios from "../../../hooks/useAxios";
import AppContext from "../../../contexts/app-context";
import { urls } from "../../config/variables";
import { validateEncounterRejectionDistributionData, validateEncountersList } from "../../../Utils/validateHttpResponse";
import Toastify from "../../ui/Toastify";
import { toastify_status } from "../../config/variables";
import EncounterCard from "../../users/EncounterCard/EncounterCard";
import Pagination from "@mui/material/Pagination";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {
  Dangerous as DangerousIcon,
  Info
} from "@mui/icons-material";

const EncounterResolution = () => {
  const [data, setData] = useState([
    { key: "accepted_encounters", title: "Accepted Encounters", color: "#29C377", valueColor: "#1E8F59", value: 0, percent: 0 },
    { key: "rejected_by_icd_only", title: "Diagnosis Claims Rejection", color: "#FF9232", valueColor: "#CC751F", value: 0, percent: 0 },
    { key: "rejected_by_cpt_only", title: "Procedure Claims Rejection", color: "#FFB16A", valueColor: "#D28A45", value: 0, percent: 0},
    { key: "rejected_by_drug_only", title: "Drug Claims Rejection", color: "#FF546F", valueColor: "#C63C53", value: 0, percent: 0 },
    { key: "rejected_by_icd_cpt", title: "Diagnosis & Procedure Claims Rejection", color: "#FF7A5C", valueColor: "#CC6249", value: 0, percent: 0 },
    { key: "rejected_by_icd_drug", title: "Diagnosis & Drug Claims Rejection", color: "#FF6B8A", valueColor: "#CC556E", value: 0, percent: 0 },
    { key: "rejected_by_cpt_drug", title: "Procedure & Drug Claims Rejection", color: "#FF8FA3", valueColor: "#CC7282", value: 0, percent: 0 },
    { key: "rejected_by_all", title: "Diagnosis & Drug & Procedure Claims Rejection", color: "#7A6FF0", valueColor: "#4E45B3", value: 0, percent: 0 },
  ]);

  const [loading, setLoading] = useState(true);
  const [flipped, setFlipped] = useState(false);
  const [selectedBarKey, setSelectedBarKey] = useState(null);

  const { operation } = useAxios();
  const authCtx = useContext(AuthContext);
  const { globalFilterQuery } = useContext(AppContext);
  const token = authCtx.token;

  const getEncounterRejectionDistributionData = () => {
    setLoading(true);
    operation(
      {
        method: 'GET',
        url: urls.ENCOUNTER_REJECTION_DISTRIBUTION + globalFilterQuery,
        headers: { Authorization: `token ${token}` },
        data: {},
      },
      handleSetData,
      handleSetDataError
    );
  };

  useEffect(() => {
    getEncounterRejectionDistributionData();
    // eslint-disable-next-line
  }, []);

  const handleSetData = (response) => {
    setLoading(false);
    if (validateEncounterRejectionDistributionData(response)) {
      setData(prev =>
        prev.map(item => ({
          ...item,
          value: response[item.key]?.encounters_count || 0,
          percent: response[item.key]?.encounters_percentage || 0,
        }))
      );
    } else {
      Toastify({
        message: "Invalid encounter rejection distribution response data",
        state: toastify_status.ERROR,
      });
    }
  };

  const handleSetDataError = (error) => {
    setLoading(false);
    console.log(error);
  };

  const handleBarClick = (barKey) => {
    setSelectedBarKey(barKey);
    setFlipped(true);
    switch (barKey) {
      case 'accepted_encounters':
        setApproved(true)
        setRejectedICD(false)
        setRejectedCPT(false)
        setRejectedDrug(false)
        break;
      case 'rejected_by_icd_only':
        setApproved(false)
        setRejectedICD(true)
        setRejectedCPT(false)
        setRejectedDrug(false)
        break;
      case 'rejected_by_cpt_only':
        setApproved(false)
        setRejectedICD(false)
        setRejectedCPT(true)
        setRejectedDrug(false)
        break;
      case 'rejected_by_drug_only':
        setApproved(false)
        setRejectedICD(false)
        setRejectedCPT(false)
        setRejectedDrug(true)
        break;
      case 'rejected_by_icd_cpt':
        setApproved(false)
        setRejectedICD(true)
        setRejectedCPT(true)
        setRejectedDrug(false)
        break;
      case 'rejected_by_icd_drug':
        setApproved(false)
        setRejectedICD(true)
        setRejectedCPT(false)
        setRejectedDrug(true)
        break;
      case 'rejected_by_cpt_drug':
        setApproved(false)
        setRejectedICD(false)
        setRejectedCPT(true)
        setRejectedDrug(true)
        break;
      case 'rejected_by_all':
        setApproved(false)
        setRejectedICD(true)
        setRejectedCPT(true)
        setRejectedDrug(true)
        break;
    
      default:
        break;
    }

  };

  const handleFlipBack = () => {
    setFlipped(false);
    setSelectedBarKey(null);
    setPage(1)
    setCount(1)
    setPatientEncounterCards([])
  };

  // back side

  const [patientEncounters, setPatientEncounters] = useState([]);
  const [patientEncounterCards, setPatientEncounterCards] = useState([]);
  const [patientEncountersError, setPatientEncountersError] = useState(undefined);
  const [loadingEcounters, setLoadingEncounters] = useState(true);
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 5

    const sortByDate = (array) => {
      return array.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB - dateA;
      });
    };
  
    const storePatientEncounterCards = (encounters) => {
      if (typeof encounters !== 'undefined') {
        return encounters.map((patientEncounter, index) => {
          return <EncounterCard key={index} encounter={patientEncounter} />;
        });
      }
    }
  
    const setFilteredPatientEncounters = (encounters) => {
      setLoadingEncounters(false)
      if(validateEncountersList(encounters)) {
        const sortedPatientEncounters = sortByDate(encounters.results);
        setPatientEncounters(sortedPatientEncounters);
        setPatientEncounterCards(storePatientEncounterCards(sortedPatientEncounters))
        setCount(Math.ceil(encounters.count / PAGE_SIZE));
      } else {
        console.log('invlid encounters list response')
        Toastify({message: 'invlid encounters list response', state: toastify_status.ERROR})
      }
    };

  const queryState = {
    "accepted_encounters": 'Approved',
    "rejected_by_icd_only": 'icds_rejected',
    "rejected_by_cpt_only": 'cpts_rejected',
    "rejected_by_drug_only": 'drugs_rejected',
    "rejected_by_icd_cpt": 'icds_cpts_rejected',
    "rejected_by_icd_drug": 'icds_drugs_rejected',
    "rejected_by_cpt_drug": 'cpts_drugs_rejected',
    "rejected_by_all": 'icds_cpts_drugs_rejected',
  }

  const handleEncounterError = () => {
      setPatientEncountersError(true)
  }

  const getEncounterRejectionDistributionAllData = () => {
    setLoadingEncounters(true)
    setPatientEncountersError(false)
    operation(
      {
        method: 'GET',
        url: `${urls.LIST_ENCOUNTERS}?state=${queryState[selectedBarKey]}&page_size=${PAGE_SIZE}&page=${page}`,
        headers: { Authorization: `token ${token}` },
        data: {},
      },
      setFilteredPatientEncounters,
      handleEncounterError,
    );
  };

  useEffect(() => {
    if(flipped) {
      setLoadingEncounters(true)
      setPatientEncounterCards([])
      setTimeout(() => {
        getEncounterRejectionDistributionAllData()
      }, 500)
    }
    // eslint-disable-next-line
  }, [flipped, page, selectedBarKey])

  const [approved, setApproved] = useState(false);
  const [rejectedICD, setRejectedICD] = useState(false);
  const [rejectedCPT, setRejectedCPT] = useState(false);
  const [rejectedDrug, setRejectedDrug] = useState(false);

  const handleApproved = () => {
    setApproved(prev => !prev);
    setRejectedICD(false);
    setRejectedCPT(false);
    setRejectedDrug(false);
  };

  const toggleRejectedICD = () => {
    setRejectedICD(prev => !prev);
    setApproved(false);
  };

  const toggleRejectedCPT = () => {
    setRejectedCPT(prev => !prev);
    setApproved(false);
  };

  const toggleRejectedDrug = () => {
    setRejectedDrug(prev => !prev);
    setApproved(false);
  };

  useEffect(() => {
    setPage(1)
    if(approved && !rejectedICD && !rejectedCPT && !rejectedDrug) {
      setSelectedBarKey('accepted_encounters')
    } else if (!approved && rejectedICD && !rejectedCPT && !rejectedDrug) {
      setSelectedBarKey('rejected_by_icd_only')
    } else if (!approved && !rejectedICD && rejectedCPT && !rejectedDrug) {
      setSelectedBarKey('rejected_by_cpt_only')
    } else if (!approved && !rejectedICD && !rejectedCPT && rejectedDrug) {
      setSelectedBarKey('rejected_by_drug_only')
    } else if (!approved && rejectedICD && rejectedCPT && !rejectedDrug) {
      setSelectedBarKey('rejected_by_icd_cpt')
    } else if (!approved && rejectedICD && !rejectedCPT && rejectedDrug) {
      setSelectedBarKey('rejected_by_icd_drug')
    } else if (!approved && !rejectedICD && rejectedCPT && rejectedDrug) {
      setSelectedBarKey('rejected_by_cpt_drug')
    } else if (!approved && rejectedICD && rejectedCPT && rejectedDrug) {
      setSelectedBarKey('rejected_by_all')
    } else {
      setSelectedBarKey('accepted_encounters')
    }
    // eslint-disable-next-line
  }, [approved, rejectedICD, rejectedCPT, rejectedDrug])

  return (
    <Box sx={{ perspective: "1000px", padding: "0 30px", overflow: 'hidden', height: flipped ? '560px' : '380px', transition: '0.5s' }}>
      <Box sx={{ margin: "10px 0" }}>
        <Typography sx={{ fontWeight: "500", fontSize: "20px" }}>
          Encounters Distribution
        </Typography>
        <Typography sx={{ fontSize: "16px", color: '#86878C' }}>
          Breakdown of encounter approvals and rejections by category (ICD codes, drugs, CPT codes, and insurance rules)
        </Typography>
      </Box>

      <motion.div
        animate={{ rotateY: flipped ? 180 : 0 }}
        style={{ transformStyle: "preserve-3d" }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
      >
        {/* FRONT SIDE - BAR CHARTS */}
        <Box
          style={{
            backfaceVisibility: "hidden",
          }}
        >
          <Box sx={{ display: "flex", gap: "30px" }}>
            <Box sx={{ flex: 1 }}>
              {data.slice(0, 4).map((d, index) => (
                <Box key={index} sx={{ marginBottom: "10px", cursor: "pointer" }} onClick={() => handleBarClick(d.key)}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                    <Typography sx={{fontSize: '14px'}}>{d.title}</Typography>
                    <Typography sx={{ fontSize: "16px", color: "#2F7CF8", fontWeight: "600", opacity: loading ? '0' : '1' }}>
                      %{parseFloat(d.percent).toFixed(2)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      position: "relative",
                      backgroundColor: "#EFF5FF",
                      borderRadius: "5px",
                      height: "35px",
                      overflow: 'hidden'
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: d.color,
                        height: "100%",
                        borderRadius: "5px",
                        width: `${d.percent}%`,
                        transition: "0.5s",
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {!loading ? (
                        <Typography
                          sx={{
                            padding: "5px",
                            borderRadius: "5px",
                            color: "#1E201E",
                            fontWeight: "600",
                            fontSize: "16px",
                            marginLeft: '10px'
                          }}
                        >
                          {d.value}
                        </Typography>
                      ) : (
                        <CircularProgress size="20px" sx={{ marginLeft: '10px', position: 'absolute' }} />
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
            <Box sx={{ flex: 1 }}>
              {data.slice(4, 8).map((d, index) => (
                <Box key={index} sx={{ marginBottom: "10px", cursor: "pointer" }} onClick={() => handleBarClick(d.key)}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                    <Typography sx={{fontSize: '14px'}}>{d.title}</Typography>
                    <Typography sx={{ fontSize: "16px", color: "#2F7CF8", fontWeight: "600", opacity: loading ? '0' : '1' }}>
                      %{parseFloat(d.percent).toFixed(2)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      position: "relative",
                      backgroundColor: "#EFF5FF",
                      borderRadius: "5px",
                      height: "35px",
                      overflow: 'hidden'
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: d.color,
                        height: "100%",
                        borderRadius: "5px",
                        width: `${d.percent}%`,
                        transition: "0.5s",
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {!loading ? (
                        <Typography
                          sx={{
                            padding: "5px",
                            borderRadius: "5px",
                            color: "#1E201E",
                            fontWeight: "600",
                            fontSize: "16px",
                            marginLeft: '10px'
                          }}
                        >
                          {d.value}
                        </Typography>
                      ) : (
                        <CircularProgress size="20px" sx={{ marginLeft: '10px', position: 'absolute' }} />
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* back side - encounters */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            backgroundColor: "#F8F9FA",
            borderRadius: "5px",
            marginBottom: '10px'
          }}
        >
          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px'}}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              width: '70%',
              height: '30px'
            }}>
            <KeyboardBackspaceIcon
              sx={{ fontSize: "40px", color: "#8ED5C8", margin: "10px", cursor: "pointer", textDecoration: "underline", fontWeight: '500' }}
              onClick={handleFlipBack}
            />
            <Button
              sx={{ margin: '0 10px', fontSize: '12px' }}
              name='approved'
              variant={
                approved ? 'contained' : 'outlined'
              }
              color='success'
              onClick={handleApproved}
              size="small"
            >
              Approved
            </Button>

            <Button
              sx={{ margin: '0 10px', fontSize: '12px' }}
              name='rejected_icds'
              variant={
                rejectedICD ? 'contained' : 'outlined'
              }
              color='error'
              onClick={toggleRejectedICD}
              size="small"
            >
              Rejected Diagnosis
            </Button>

            <Button
              sx={{ margin: '0 10px', fontSize: '12px' }}
              name='rejected_cpts'
              variant={
                rejectedCPT ? 'contained' : 'outlined'
              }
              color='error'
              onClick={toggleRejectedCPT}
              size="small"
            >
              Rejected Procedures
            </Button>

            <Button
              sx={{ margin: '0 10px', fontSize: '12px' }}
              name='rejected-drugs'
              variant={
                rejectedDrug ? 'contained' : 'outlined'
              }
              color='error'
              onClick={toggleRejectedDrug}
              size="small"
            >
              Rejected Drugs
            </Button>
          </Box>

          <Box>
            {!loadingEcounters && count > 1 && <Pagination
              page={page}
              count={count}
              onChange={(e, v) => setPage(v)}
              color="primary"
              size="small"
            />}
          </Box>

          </Box>
          
            <Box sx={{paddingBottom: '10px'}}>
              <Box sx={{height: '400px', overflow: 'scroll'}}>
              {loadingEcounters 
              ? <Box sx={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                    <CircularProgress size="60px" sx={{  }} />
              </Box> 
                : !loadingEcounters && patientEncountersError
                  ? <Box sx={{margin: '10px'}}>
                      <Alert icon={<DangerousIcon />} severity="error">
                        Something went wrong.
                      </Alert>
                    </Box>
                    : patientEncounters.length === 0
                    ? <Box sx={{margin: '10px'}}>
                      <Alert icon={<Info />} severity="info">
                        No encounters available for this state
                      </Alert>
                    </Box>
                  : <Box sx={{ margin: '20px 0', padding: '0 10px' }}>
                {patientEncounterCards}
                </Box>}
            </Box>
            </Box>
        </Box>
      </motion.div>
    </Box>
  );
};

export default EncounterResolution;
